import ReactMarkdown from 'react-markdown';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import rehypeRaw from 'rehype-raw';

type TMartkdownHtmlProps = {
    content?: string;
};

export const MartkdownHtml = ({ content }: TMartkdownHtmlProps) => {
    return (
        <ReactMarkdown rehypePlugins={[rehypeRaw] as PluggableList}>{content || ''}</ReactMarkdown>
    );
};
